import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

/* GivingCare Lumen design system.
 * Order matters: tokens define the variables everything else reads, base
 * resets and paints the page, then the material and component layers stack
 * on top in increasing specificity. */
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/glass.css";
import "./styles/controls.css";
import "./styles/table.css";
import "./styles/modal.css";
import "./styles/feedback.css";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
